<svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path
    d='M11.3335 12.2426C8.99039 14.5858 5.1914 14.5858 2.84825 12.2426C0.505105 9.89949 0.505105 6.10051 2.84825 3.75736C5.1914 1.41421 8.99039 1.41421 11.3335 3.75736'
    stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  <path d='M13.7578 6L15.5356 8L13.7578 10' stroke='white' stroke-width='2' stroke-linecap='round'
        stroke-linejoin='round' />
  <path d='M15.4238 8L7.09049 8' stroke='white' stroke-width='2' stroke-linecap='round' />
</svg>
